import ColorPicker from "components/ColorPicker"
import ImageEditor from "components/ImageEditor"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row, Tooltip } from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"

const BackgroundTab = ({
  bgImage,
  change,
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Background</h4>
        </CardHeader>
        <CardBody>
          <Row className="my-3">
            <Col xs={12} xl={2}>
              <label>Color:</label>
            </Col>
            <Col xs="auto">
              <Field name="bgColor" type="color" component={ColorPicker} />
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              xl={2}
              className="my-1"
              style={{ minWidth: "fit-content" }}
            >
              <label>
                Image:&nbsp;
                <i className="fas fa-question-circle" id="contactUsBg"></i>
                &nbsp;
              </label>
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target="contactUsBg"
                toggle={toggle}
              >
                <b>NOTE:</b> For best results, size image to: 1440px x 2960px
              </Tooltip>
            </Col>
            <Col xs="auto" className="my-1">
              <Field
                name="bgImage"
                type="file"
                component={ImageEditor}
                onDelete={() => {
                  change("design.background.deleteBgImage", 1)
                }}
                onChange={() => {
                  change("design.background.deleteBgImage", 1)
                }}
              />
            </Col>
            <Col
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              {bgImage && bgImage?.editedImage && (
                <img
                  src={bgImage?.editedImage ? bgImage?.editedImage : ""}
                  alt="bgImage"
                  className="rounded avatar-xl"
                  style={{ blockSize: "auto" }}
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.CONTACT_US)

const mapStateToProps = state => ({
  bgImage: selector(state, "design.background.bgImage"),
  isDirty: isDirty(FORM_NAMES.CONTACT_US)(state, ...["design.background"]),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.CONTACT_US, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.CONTACT_US)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundTab)
